<div>
  <div class="row mt-3">
    <div class="col-9">
      <div class="mb-3 d-flex justify-content-between">
        <h2 class="title-list">List of Users</h2>
      </div>
    </div>
    <div class="col-3 text-end">
      <div class="d-flex flex-row-reverse bd-highlight">
        <div class="me-3">
          <!-- <button
            *ngIf="
              permissionsService.editPermission &&
              permissionsService.readPermission
            "
            class="btn btn-secondary"
            (click)="exportCustomerListToExcel()"
          >
            <i class="bi bi-file-earmark-excel"></i>
          </button> -->
        </div>

        <div class="me-3">
          <button
            class="btn btn-secondary"
            (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)"
          >
            <i class="bi bi-archive"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          <i class="bi bi-search"></i>
        </span>
        <input
          type="text"
          class="form-control input-label"
          placeholder="Search"
          [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()"
        />
      </div>
    </div>
  </div>
  <div class="row d-none d-md-block">
    <div class="col-12">
      <div class="table-responsive rounded-5">
        <table class="table table-striped mb-0">
          <caption class="d-none">
            List of users and their details
          </caption>
          <thead class="head-table">
            <tr>
              <th class="px-4 py-3 align-middle">User Account</th>
              <th class="px-4 py-3 align-middle">Name</th>
              <th class="px-4 py-3 align-middle">Email</th>
              <th class="px-4 py-3 align-middle">Contact Number</th>
              <th class="px-4 py-3 align-middle">Status</th>
              <th class="px-4 py-3 align-middle">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let customer of customers
                  | search : textoBusqueda : camposBusqueda
                  | slice
                    : (paginationService.currentPage - 1) *
                        paginationService.recordsPerPage
                    : paginationService.currentPage *
                        paginationService.recordsPerPage
              "
            >
              <td
                class="px-4 py-3 align-middle"
                [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                title="{{ customer.userId }}"
              >
                {{ customer.userId }}
              </td>
              <td
                class="px-4 py-3 align-middle"
                [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                title="{{ customer.userNames }}"
              >
                {{ customer.userNames }}
              </td>
              <td
                class="px-4 py-3 align-middle"
                [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                title="{{ customer.userMail }}"
              >
                {{ customer.userMail }}
              </td>
              <td
                class="px-4 py-3 align-middle"
                [style.opacity]="customer.userStatus === 0 ? '0.6' : '1'"
                title="{{ customer.userPhone }}"
              >
                {{ customer.userPhone }}
              </td>
              <td class="px-4 py-3 align-middle">
                <div
                  *ngIf="customer.userStatus === 0 || customer.userStatus === 1"
                  class="form-check form-switch"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="customer.userStatus"
                    id="flexSwitchCheckDefault"
                    [checked]="customer.userStatus === 1"
                    [disabled]="!permissionsService.readPermission"
                    (change)="
                      toggleStatus($event, customer);
                      setSelectedCustomer(customer);
                      openConfirmationModal(customer)
                    "
                    data-bs-toggle="modal"
                    data-bs-target="#modalSwitch"
                  />
                </div>
                <div *ngIf="customer.userStatus === 2">
                  <span class="archived">Archived</span>
                </div>
              </td>
              <td class="px-4 py-3 align-middle">
                  <div class="d-flex gap-2">
                      <!-- Botón Editar con icono pencil-square -->
                      <button *ngIf="
                      customer.userStatus !== 2 &&
                      permissionsService.readPermission
                    "
                              class="btn btn-info"
                              (click)="navigateToUpdateUser(customer)"
                              style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
                              appTooltip="Edit Customer">
                          <i class="bi bi-pencil-square" style="color: #146c43"></i>
                      </button>

                      <!-- Кнопка «Удалить» со значком «Архив» -->
                      <button *ngIf="
                      customer.userStatus !== 2 &&
                      permissionsService.readPermission
                    "
                              class="btn btn-danger"
                              data-bs-toggle="modal"
                              data-bs-target="#modalArchive"
                              (click)="setArchivedCustomer(customer)"
                              style="background-color: #f8d7da; border: 3px solid #f8d7da"
                              appTooltip="Archive Customer User">
                          <i class="bi bi-archive" style="color: #b02a37"></i>
                      </button>

                      <!-- Кнопка «Восстановить» со значком «Архив» -->
                      <button *ngIf="
                      customer.userStatus === 2 &&
                      permissionsService.readPermission
                    " 
                              class="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#modalArchive"
                              (click)="setArchivedCustomer(customer)"
                              
                              style="background-color: #7ab956; border: 3px solid #7ab956 "
                              appTooltip="Restore Customer User">
                        <i class="bi bi-archive"></i>
                      </button>


                      <!-- Botón View con icono eye -->
                      <!-- <button
      class="btn btn-success"
      style="background-color: #cfe2ff; border: 3px solid #cfe2ff"
      *ngIf="permissionsService.readPermission"
      (click)="navigateToCustomerView(customer)"
      appTooltip="View Customer"
    >
      <i class="bi bi-eye" style="color: #0a58ca"></i>
    </button> -->
                      <!-- Botón Asignar Users con icono de asignación de usuarios -->
                      <!-- <button
      *ngIf="
        customer.userStatus !== 2 &&
        permissionsService.readPermission
      "
      class="btn btn-info"
      (click)="navigateToCustomerUsers(customer)"
      style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
      appTooltip="Assign User"
    >
      <i class="bi bi-person-plus" style="color: #146c43"></i>
    </button> -->
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Cards para mobile -->
  <div class="row d-md-none">
    <div class="col-12">
      <div
        *ngFor="
          let customer of customers
            | search : textoBusqueda : camposBusqueda
            | slice
              : (paginationService.currentPage - 1) *
                  paginationService.recordsPerPage
              : paginationService.currentPage * paginationService.recordsPerPage
        "
        class="card mb-3"
      >
        <div class="card-body">
          <h5 class="card-title">{{ customer.userNames }}</h5>
          <p class="card-text">
            <strong>Account:</strong> {{ customer.userId }}<br />
            <strong>Email:</strong> {{ customer.userMail }}<br />
            <strong>Phone:</strong> {{ customer.userPhone }}<br />
          </p>
          <div class="d-flex gap-2">
            <div
              *ngIf="customer.userStatus === 0 || customer.userStatus === 1"
              class="form-check form-switch"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="customer.userStatus"
                id="flexSwitchCheckDefault"
                [checked]="customer.userStatus === 1"
                [disabled]="!permissionsService.readPermission"
                (change)="
                  toggleStatus($event, customer);
                  setSelectedCustomer(customer);
                  openConfirmationModal(customer)
                "
                data-bs-toggle="modal"
                data-bs-target="#modalSwitch"
              />
            </div>
            <div *ngIf="customer.userStatus === 2">
              <span class="archived">Archived</span>
            </div>
            <!-- Botón Editar con icono pencil-square -->
            <button
              *ngIf="
                customer.userStatus !== 2 && permissionsService.readPermission
              "
              class="btn btn-info"
              (click)="navigateToUpdateUser(customer)"
              style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
              appTooltip="Edit Customer"
            >
              <i class="bi bi-pencil-square" style="color: #146c43"></i>
            </button>

            <!-- Botón Delete con icono archive -->
            <button
              *ngIf="
                customer.userStatus !== 2 &&
                permissionsService.readPermission
              "
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#modalArchive"
              (click)="setArchivedCustomer(customer)"
              style="background-color: #f8d7da; border: 3px solid #f8d7da"
              appTooltip="Archive Customer"
            >
              <i class="bi bi-archive" style="color: #b02a37"></i>
            </button>

            <!-- Botón View con icono eye -->
            <!-- <button
                class="btn btn-success"
                style="background-color: #cfe2ff; border: 3px solid #cfe2ff"
                *ngIf="permissionsService.readPermission"
                (click)="navigateToCustomerView(customer)"
                appTooltip="View Customer"
              >
                <i class="bi bi-eye" style="color: #0a58ca"></i>
              </button> -->
            <!-- Botón Asignar Users con icono de asignación de usuarios -->
            <!-- <button
              *ngIf="
                customer.userStatus !== 2 && permissionsService.readPermission
              "
              class="btn btn-info"
              (click)="navigateToCustomerUsers(customer)"
              style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
              appTooltip="Assign User"
            >
              <i class="bi bi-person-plus" style="color: #146c43"></i>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginacion -->
  <div class="row">
    <div class="col-12">
      <label>
        Showing
        {{
          (paginationService.currentPage - 1) *
            paginationService.recordsPerPage +
            1
        }}
        to
        {{
          paginationService.currentPage * paginationService.recordsPerPage <
          filteredCustomers.length
            ? paginationService.currentPage * paginationService.recordsPerPage
            : filteredCustomers.length
        }}
        out of {{ filteredCustomers.length }} entries
      </label>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li
            class="page-item"
            [class.disabled]="paginationService.currentPage === 1"
          >
            <a
              class="page-link"
              href="javascript:void(0)"
              tabindex="-1"
              aria-disabled="true"
              (click)="previousPage()"
            >
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <ng-container *ngIf="pages.length > 0">
            <ng-container *ngFor="let page of pages">
              <li
                class="page-item"
                [class.active]="page === paginationService.currentPage"
              >
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  (click)="changePage(page)"
                  >{{ page }}</a
                >
              </li>
            </ng-container>
          </ng-container>
          <li
            class="page-item"
            [class.disabled]="
              paginationService.currentPage === paginationService.totalPages ||
              filteredCustomers.length <= paginationService.recordsPerPage
            "
          >
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="modalSwitch"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
            style="font-weight: bold"
          >
            User Active/Inactive
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="updateUserStatus(false)"
          ></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this user?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(false)"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(true)"
          >
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="modalArchive"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title"
                id="exampleModalLabel"
                style="font-weight: bold">
                Customer User {{isFilteredByStatus ? 'Restore' : 'Archive'}}
            </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="updateUserStatus(false)"
          ></button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this user?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(false)"
          >
            Close
          </button>
          <button type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  (click)="updateUserStatus(true)">
              Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
